import { pathBuilder } from './index';

export const root = '/admin/contracts';
export default pathBuilder(root);
